/* global axios */
import ApiClient from '../ApiClient';

class CaptainAiActionLogs extends ApiClient {
  constructor() {
    super('captain/ai_action_logs', { accountScoped: true });
  }

  get({ page = 1, status, assistantId, conversationId, toolId } = {}) {
    return axios.get(this.url, {
      params: {
        page,
        status,
        assistant_id: assistantId,
        conversation_id: conversationId,
        tool_id: toolId,
      },
    });
  }
}

export default new CaptainAiActionLogs();
